import { Component, ElementRef, ViewChild } from '@angular/core';
import { FullscreenService } from './../../../../core/services/fullscreen.service';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { CurrentUserService } from '../../../../core/services/user/current-user.service';
import { CaseStatus } from '../../../../../enums/case-status.enum';
import { Chart, registerables } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DiabetesCaseInformation } from '../../../../core/models/patient/diabet-case-information.model';
import { UserSessionModel } from '../../../../core/models/user/current-user.model';
import { TabsModel } from '../../../../core/models/tabs.model';
import { CaseInformationComponent } from '../../../components/patient-detail/case-information/case-information.component';
import { AiReportComponent } from '../../../components/patient-detail/ai-report/ai-report.component';
import { ChatComponent } from '../../../components/patient-detail/chat/chat.component';
import { ConclusionComponent } from '../../../components/consultation-detail/conclusion/conclusion.component';
@Component({
  selector: 'app-consultation-detail',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    CaseInformationComponent,
    AiReportComponent,
    ChatComponent,
    ConclusionComponent,
  ],
  templateUrl: './consultation-detail.component.html',
  styleUrl: './consultation-detail.component.scss',
  providers: [DatePipe],
})
export class ConsultationDetailComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;

  constructor(
    private fullscreenService: FullscreenService,
    private route: ActivatedRoute,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService,
    private currentUserService: CurrentUserService,
    private translateService: TranslateService
  ) {
    Chart.register(...registerables);
    this.translateService.setDefaultLang('tr');
    this.translateService.use('tr');
  }
  tabs: TabsModel[] = [];
  caseStatus = CaseStatus;
  selectedItem: any;
  consultationId: string = '';
  patientHeaderInformations: any = [];
  timeLineList: any = [];
  patientCaseDetails: any = [];
  selectedIndex: number | null = null;
  currentUser: UserSessionModel | null = null;
  conclusionOptions: any = [];
  selectedConclusionText: string = '';
  selectedConclusions: { [key: string]: string } = {};
  patientRapport: any = null;
  isConsultationReportTabActive = false;
  file: File | null = null;
  fileCount: any = null;
  userInput: string = '';
  isUpdatingFromInput = false;
  previewReportErrorText: string = '';
  patientRecordCaseDetail: any;
  diabetesCaseInformation: DiabetesCaseInformation;
  activeTabList: string[] = [];

  ngOnInit() {
    this.fullscreenService.initializeFullscreenButtons();
    this.consultationId = this.route.snapshot.paramMap.get('id')!;
    this.currentUser = this.currentUserService.GetSession();
    if (this.consultationId) {
      this.getConsultationDetailById(this.consultationId);
      this.getConsultationTimeLineList(this.consultationId);
      this.getPatientRecordCaseDetail(this.consultationId);
    }
  }

  ngAfterViewInit() {
    this.tabs = [
      {
        id: 'caseDetail',
        name: `${this.translateService.instant('caseDetail')}`,
        href: '#caseDetail',
        active: true,
        display: 'block',
      },
      {
        id: 'aiReport',
        name: `${this.translateService.instant('aiReport')}`,
        href: '#aiReport',
        active: false,
        display: 'block',
      },
      {
        id: 'conclusion',
        name: `${this.translateService.instant('conclusion')}`,
        href: '#conclusion',
        active: false,
        display: 'block',
      },
      {
        id: 'chatWithGp',
        name: `${this.translateService.instant('chatWithGp')}`,
        href: '#chatWithGp',
        active: false,
        display: 'block',
      },
    ];
  }

  selectTab(tab: TabsModel) {
    this.activeTabList.push(tab.id);
  }

  getPatientRecordCaseDetail(id: string) {
    if (id) {
      this.patientsService.getPatientRecordCaseDetail(id).subscribe({
        next: (res) => {
          this.patientRecordCaseDetail = res;
          this.diabetesCaseInformation = res?.diabetesCaseInformation;
        },
      });
    }
  }

  getConsultationDetailById(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          this.patientHeaderInformations = res;
        },
      });
  }

  getConsultationTimeLineList(id: string) {
    this.patientsService
      .consultationTimeLineListByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          this.timeLineList = res;
          this.getPatientCaseDetail(id);
        },
      });
  }

  showCaseDetails(index: number, selectItem: any): void {
    if (selectItem.patientRecordCaseId) {
      this.selectedIndex = index;
      this.getPatientInformations(selectItem.patientRecordCaseId);
      this.getPatientCaseDetail(selectItem.patientRecordCaseId);
    }
  }

  getPatientInformations(id: string) {
    this.consultationsService
      .consultationDetailByPatientRecordCaseId(id)
      .subscribe({
        next: (res) => {
          this.patientHeaderInformations = res;
        },
      });
  }

  getPatientCaseDetail(id: string) {
    this.patientsService.patientRecordCaseDetail(id).subscribe({
      next: (res) => {
        this.patientCaseDetails = res;
        this.selectedConclusionText = res?.conclusion;
      },
    });
  }
}
